// https://vuex.vuejs.org/en/actions.html

export default {
  changeLanguage ({ commit }, payload) {
    commit('onLangChanged', payload)
  },
  setCurrentUser({commit},payload){
    commit('setCurrentUser',payload)
  }
}
